import { Component, Input } from "@angular/core";
import { StateService } from '@uirouter/angular';

@Component({
    selector: 'frs-tabs',
    template: `<ul class="nav nav-tabs glyph-group-xs" role="tablist" style="margin-top: 0px;">
    <li role="presentation" [ngClass]="{active: $state.is('home.project.summary.frs')}">
        <a uiSref="home.project.summary.frs"
            aria-controls="releases" role="tab">
            <gf-glyph class="glyph-img-release"
                aria-hidden="false"></gf-glyph>
            <span translate>Releases</span>
        </a>
    </li>
    <li role="presentation" [ngClass]="{active: $state.is('home.project.summary.frs.roadmap')}">
        <a uiSref="home.project.summary.frs.roadmap"
            aria-controls="roadmap" role="tab">
            <i class="glyphicon glyphicon-tasks"
                aria-hidden="false"></i>
            <span translate>Roadmap</span>
        </a>
    </li>
    <li role="presentation" *ngIf="release" class="active">
        <a href="#release-tab" aria-controls="release" role="tab" data-toggle="tab">
            <gf-glyph class="glyph-img-release"
                aria-hidden="false"></gf-glyph>
            <span>{{release.package.packageName}}::{{release.releaseName}}</span>
        </a>
    </li>
</ul>`
})
export class FrsTabsComponent {

    @Input() release: any = null;

    constructor(
        public $state: StateService
    ) {}
}